<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.LOADING.START"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.LOADING.FINISH"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent ref="modal" type="ui-less" v-slot="{ dialogVisible }">
    <Transition name="fade">
      <div
        class="h-full w-full fixed z-100 top-0 left-0 flex items-center justify-center text-center p-6"
        v-if="dialogVisible"
      >
        <ImgComponent
          src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
          class="w-[60vw] animate-spin opacity-70 p-[20%] absolute"
        />
      </div>
    </Transition>
  </DialogComponent>
</template>
